import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';
import { useMapsGeo } from '../../address-form.hooks';

const LatitudeField = ({ name, ...rest }) => {
  const { t } = useTranslation();
  useMapsGeo(name, 'latitude');

  return (
    <IncTextField
      name={name}
      label={t('forms.fields.latitude.label')}
      data-testid="LatitudeField"
      {...rest}
    />
  );
};
export default LatitudeField;
